// extracted by mini-css-extract-plugin
module.exports = {"base":"skeleton_base__gz7Im","shimmer":"skeleton_shimmer__3NKdt","circular":"skeleton_circular__3nC_F"};